export default __webpack_public_path__ + "static/media/edit-icon.b034f20e.png";